import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot} from '@angular/router';
import {ApiService} from '../../api/api.service';
import {EMPTY, Observable} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {HttpErrorResponse} from '@angular/common/http';
import {OnboardingError} from '../../api/errors';
import {OnboardingState} from 'smag-commons/dto/api/onboarding';
import {errorCode} from '../../commons/commons';

@Injectable()
export class OnboardingResolverService implements Resolve<OnboardingState> {
    constructor(private readonly router: Router,
                private readonly api: ApiService) {
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<OnboardingState> {
        const totp = route.queryParamMap.get('totp');
        return this.api.getMember(totp).pipe(
            catchError(err => {
                this.handleInvalidOnboarding(totp,
                    err instanceof HttpErrorResponse ? mkError(err.status, errorCode(err)) : OnboardingError.GENERIC);
                return EMPTY;
            })
        );
    }

    private handleInvalidOnboarding(totp: string, error: OnboardingError) {
        this.router.navigate(['/c', 'onboarding-invalid'], {
            queryParams: {totp, error},
            queryParamsHandling: 'merge'
        });
    }
}

function mkError(status: number, code: number): OnboardingError {
    if (status === 404) {
        return OnboardingError.TOTP_NOT_EXISTING;
    } else if (status === 400) {
        switch (code) {
            case 1009:
                return OnboardingError.ALREADY_REGISTERED;
            case 1010:
                return OnboardingError.TOTP_EXPIRED;
        }
    }
    return OnboardingError.GENERIC;
}
